import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProcessoService } from '@app/services/processo.service';
import { FuncionarioService } from '@app/services/funcionario.service';
import { Funcionario } from '@app/models/funcionario';
import { ProcessoArquivoService } from '@app/services/processo-arquivo.service';
import { ProcessoResumo } from '@app/models/processo.model';
import { ConsultasService } from '@app/services/consultas.service';
import { IdDescricao } from '@app/models/util/id-descricao';

@Component({
  selector: 'app-encaminhar-pasta',
  templateUrl: './encaminhar-pasta.component.html',
  styleUrls: ['./encaminhar-pasta.component.scss']
})
export class EncaminharPastaComponent implements OnInit {

  lstErros: string[];

  lstFuncionario: IdDescricao[] = [];

  ficha: string;
  funcionarId = null;

  processoResumo: ProcessoResumo;
  pesquisaResultado: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private consultasService: ConsultasService,
    private processoService: ProcessoService,
    private processoArquivoService: ProcessoArquivoService,
  ) { }

  ngOnInit() {
    this.consultasService.consultar('USUARIO').toPromise().then((data) => this.lstFuncionario = data);
  }


  obterProcessoResumo() {
    if (this.ficha != '') {
      this.processoArquivoService.obterProcessoResumo(this.ficha).subscribe(
        (data: any) => {
          if (data) {
            this.pesquisaResultado = data.ClienteNome;
          } else {
            this.pesquisaResultado = 'Ficha não encontrada';
          }
        },
        (data: any) => {
          this.pesquisaResultado = 'Ficha não encontrada';
        });
    }

  }

  adicionar() {
    this.processoArquivoService.encaminharPastaPorFicha(this.funcionarId, this.ficha).subscribe(
      () => this.router.navigate(['./processos', 'solicitacoes-pastas']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
      });
  }
}
